import { codeItemToStoreValue } from 'app/infrastructure/data/codes';
import { parseAsDateUTC } from 'app/infrastructure/data/date';
import { ListBranchItem } from '../types-store';
import { ListBranchItemWire } from '../types';

export const mapListBranchItemFromWire = (listBranchItems: ListBranchItemWire[]): ListBranchItem[] =>
  listBranchItems?.map(item => ({
    id: item.code?.v,
    description: item.code?.d,
    disabled: parseAsDateUTC(item.disabled),
    colour: item.decimalColour,
    icon: item.icon,
    childrenCount: item.descendantCount || 0,
    ...(!!item.node && {
      node: {
        value: item.node.v,
        description: item.node.d,
        longDescription: item.node?.ld,
        disabled: parseAsDateUTC(item.node.disabled)
      }
    }),
    ...(!!item.subset && {
      userGroup: item.subset.map(codeItemToStoreValue)
    }),
    ...(!!item.application && {
      caseType: item.application.map(codeItemToStoreValue)
    }),
    ...(!!item.class && {
      type: item.class.map(codeItemToStoreValue)
    })
  })) || [] as ListBranchItem[];
